import { defineComponent as _defineComponent } from 'vue'
import { computed, reactive, watch } from 'vue';
import { useToaster } from '@/composables/toaster';
import CInput from '@/components/shared/CInput.vue';
import CButton from '@/components/shared/CButton/CButton.vue';
import type { ImagePlaceholderElement } from '@/typings/customilyElements/canvasElements';
import type { CanvasEx } from '@/typings/canvas';
import { generateWordSearchPuzzleImage } from '@/api/wordSearchPuzzle';


export default /*#__PURE__*/_defineComponent({
  __name: 'WordSearchTester',
  props: {
    canvas: null,
    imageElement: null,
    editMode: { type: Boolean }
  },
  emits: ["trigger-loading"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'trigger-loading', isLoading: boolean, msg?: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    canvas: CanvasEx;
    imageElement?: ImagePlaceholderElement;
    editMode?: boolean;
};





const model = reactive({
    elementId: 0,
    words: 'apple, banana, orange, strawberry, grape'
});

const disabled = computed(() => !!props.imageElement?.locked);

const processedWords = computed(() =>
    model.words
        .split(/[ ,]+/)
        .map((word) => word.trim())
        .filter(Boolean)
);

watch(
    () => props.imageElement,
    (element) => {
        if (!element || !element.wordSearchConfig) return;
        model.elementId = element.id;
    },
    { immediate: true }
);

const updateElementId = () => {
    if (props.imageElement) {
        // eslint-disable-next-line vue/no-mutating-props
        props.imageElement.id = model.elementId;
    }
};

const setImageTesting = (canvas: CanvasEx, element: ImagePlaceholderElement, base64: string): Promise<void> => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
            element.setElement(img);
            element.testingUrl = img.src;
            canvas.requestRenderAll();
            resolve();
        };
        img.onerror = (e) => {
            console.error('Failed to load word search image:', e);
            reject(e);
        };
        img.crossOrigin = 'Anonymous';
        img.src = `data:image/png;base64,${base64}`;
    });
};

const toaster = useToaster();
const generateWordSearch = async () => {
    const element = props.imageElement;
    const config = element?.wordSearchConfig;
    if (!config || !processedWords.value.length) return;

    try {
        emit('trigger-loading', true, 'Generating word search...');
        const { base64 } = await generateWordSearchPuzzleImage(processedWords.value, config);
        await setImageTesting(props.canvas, element, base64);
    } catch (error) {
        console.error('Error generating word search:', error);
        toaster.error('An error occurred while generating the Word Search image');
    } finally {
        emit('trigger-loading', false);
    }
};

return { __sfc: true,props, emit, model, disabled, processedWords, updateElementId, setImageTesting, toaster, generateWordSearch, CInput, CButton }
}

})